/* eslint-disable array-bracket-newline */
import { useSelector } from 'react-redux';
import { enums, helpers } from '@kattana-io/common';
import TradingPlaceholder from './common/TradingPlaceholder';
import DexTrading from './sections';
import useDevice from '../../pages/MainPage/useMobileDetect';
import { IStore } from '../../reducers';
import { getNetworkFlags } from '../../wallet/helpers';
import CexSwap from './sections/Swap/CexSwap';
import { ECEXExchangeName } from '../../reducers/cex_trading';
import { networksBySym } from '../NetworkSelector/core';

const notSupportedChainPlaceholder =
  'Trading is not available on this chain yet';

const supportedEVMTradingChains = [1, 56, 137, 250, 42161, 43114, 10, 10242];

export const supportedCEXTradingExchanges: string[] = [
  ECEXExchangeName.binance,
  ECEXExchangeName.gate,
  ECEXExchangeName.bybit,
  helpers.exchanges.BINANCE,
  helpers.exchanges.GATEIO,
  helpers.exchanges.BYBIT,
];

const getCurrentExchangeName = (exchange: string) => {
  switch (exchange) {
  case helpers.exchanges.BINANCE:
    return ECEXExchangeName.binance;
  case helpers.exchanges.GATEIO:
    return ECEXExchangeName.gate;
  case helpers.exchanges.BYBIT:
    return ECEXExchangeName.bybit;
  default:
    return exchange;
  }
};

const Trading = () => {
  const chain = useSelector((state: IStore) => state.current.chain);
  const exchange = useSelector((state: IStore) => state.current.exchange);
  const kind = useSelector((state: IStore) => state.current.kind);
  const layout = useSelector((state: IStore) => state.layout);

  const { isMobile } = useDevice();
  const height =
    isMobile || (!layout.info && !layout.pool) ? '100%' : 'max-content';

  if (kind === enums.ETickerKind.CEX) {
    return (
      <CexSwap exchange={getCurrentExchangeName(exchange)} height={height} />
    );
  }

  const networkId = networksBySym[chain]?.toDecimal();
  const { isEVM, isElrond, isTon } = getNetworkFlags(networkId);

  const isTradingSupported =
    networkId &&
    ((isEVM && supportedEVMTradingChains.includes(networkId)) ||
      isElrond ||
      isTon);

  if (isTradingSupported) {
    return <DexTrading height={height} />;
  }

  return (
    <TradingPlaceholder text={notSupportedChainPlaceholder} height={height} />
  );
};

export default Trading;
